import * as React from "react";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Box,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { headCells } from "./Utils/TableHeadlist";
import { useSelector } from "react-redux";

interface Data {
  customerName: string;
  // age: string;
  phone: string;
  status: string;
  address: string;
  bloodTestDate: string;
  bloodTestTime: string;
}

interface EnhancedTableProps {
  order: any;
  orderBy: string;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler: any =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          return (
            <>
              <TableCell
                className="table-head"
                key={headCell.id}
                align="left"
                // sortDirection={orderBy === headCell.id ? order : false}
              >
                {/* <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                > */}
                  {headCell.label}
                  {/* {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null} */}
                {/* </TableSortLabel> */}
              </TableCell>
            </>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
export default React.memo(EnhancedTableHead);
